export const LOGIN_CALLBACK_PATH = "/redirecting-you-swiftly";

export const getLoginUrl = (): string => {
  const authBaseUrl = import.meta.env.VITE_AUTH_APP_BASE_URL;
  const normalizedAuthBaseUrl = authBaseUrl.endsWith("/")
    ? authBaseUrl.slice(0, -1)
    : authBaseUrl;
  const loginUrl = new URL(`${normalizedAuthBaseUrl}/signin`);
  loginUrl.searchParams.set(
    "redirect_uri",
    `${window.location.origin}${LOGIN_CALLBACK_PATH}`,
  );
  return loginUrl.toString();
};

export const redirectUserToLogin = () => window.location.assign(getLoginUrl());

// needed for production
export const CONSOLE_1_KAS_DEPLOYMENT_URL =
  import.meta.env.VITE_BREV_KAS_DOMAIN || "unknown";

export const isLocalHost = window.location.hostname.includes("localhost");
export const KAS_HOST = import.meta.env.VITE_NGC_DOMAIN || "unknown";
const KAS_BASE_URL = import.meta.env.VITE_NGC_BASE_URL || "unknown";
export const KAS_TOKEN_STORAGE_KEY = "kas-token";

export const prependKasUrl = (endpoint: string): string => {
  // When running on localhost:3000, use the proxy route to avoid CORS issues.
  return `${KAS_BASE_URL}${endpoint}`;
};

// decodeJwtSub returns a JWT's `sub` claim, unverified — telemetry only.
export const decodeJwtSub = (token: string | null): string | undefined => {
  if (!token) return undefined;
  try {
    const payload = token.split(".")[1];
    return JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/"))).sub;
  } catch {
    return undefined;
  }
};
